import { Preview } from "../components/Preview";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import Video from "../components/Video";
import HomeBannerOverlay from "../components/HomeBannerOverlay";

const Home = () => {
    return (
        <div className="m-0 p-0" style={{ background: "var(--brand-black)" }}>
            <div className="relative m-0 p-0">
                <Header overlay />
                <HomeBannerOverlay
                    imageUrl="https://ik.imagekit.io/dnddecpho/dndream/bgproject_UlxbKFd-j.jpg?updatedAt=1710473718425"
                    title="D&Dream Property"
                />
                <Video url="https://ik.imagekit.io/dnddecpho/dndream/D&D_CarConvoy2024_d3BvBxmYj.mp4?updatedAt=1739982689534" />
            </div>
            <Preview />
            <Footer />
        </div>
    );
};

export default Home;
